import { render } from "./StepFour.vue?vue&type=template&id=bebf18d8&scoped=true&ts=true"
import script from "./StepFour.vue?vue&type=script&lang=ts"
export * from "./StepFour.vue?vue&type=script&lang=ts"

import "./StepFour.vue?vue&type=style&index=0&id=bebf18d8&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bebf18d8"]])

export default __exports__